import { E_OFFICE_PREFIX_URL } from '../../e-office-layout/constants/config.e-office-layout'

export const DAT_PHONG_HOP_SHORT_PREFIX_URL = '/dat-phong-hop'
export const DAT_PHONG_HOP_PREFIX_URL = `${E_OFFICE_PREFIX_URL}${DAT_PHONG_HOP_SHORT_PREFIX_URL}`
